/**
 * Admin access JWT helpers (UX scheduling only — cookie HttpOnly is authority).
 * Port of customer `parseAccessTokenExpMs` / `isAccessTokenExpired`.
 */

function decodeJwtPayloadPart(payloadPart: string): Record<string, unknown> | null {
  try {
    const normalized = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
    const pad = normalized.length % 4 === 0 ? '' : '='.repeat(4 - (normalized.length % 4));
    const json = atob(`${normalized}${pad}`);
    const parsed: unknown = JSON.parse(json);
    if (parsed !== null && typeof parsed === 'object') {
      return parsed as Record<string, unknown>;
    }
  } catch {
    return null;
  }
  return null;
}

/** UX-only — never use for security decisions. */
export function parseAccessTokenExpMs(accessToken: string): number | null {
  const parts = accessToken.split('.');
  const payloadPart = parts[1];
  if (payloadPart === undefined) {
    return null;
  }
  try {
    const json = decodeJwtPayloadPart(payloadPart);
    if (json === null) {
      return null;
    }
    if (typeof json.exp === 'number' && Number.isFinite(json.exp)) {
      return json.exp * 1000;
    }
  } catch {
    return null;
  }
  return null;
}

export function isAccessTokenExpired(accessToken: string, skewMs = 7_000): boolean {
  const expMs = parseAccessTokenExpMs(accessToken);
  if (expMs === null) {
    return true;
  }
  return Date.now() >= expMs - skewMs;
}
